import type * as THREE from 'three/webgpu';
import type { MeasureClosestPointResult } from '../types/measure-distance-types';
import { computeCenterToTargetReferencePoint } from './measureArcCircleReferencePoints';
import type { MeasureArcCircleMixedContext } from './measureArcCircleMixedReferencePoints';
import { extractMixedMinimumSidePoints } from './measureArcCircleMixedCenterToCenter';

/**
 * 基于混合最小距离结果派生最大距离参考点对。
 *
 * 设计说明：
 * 1. 非圆侧参考点 B 与最小距离保持一致（点/线/面/原点/基准面/基准线均适用）；
 * 2. 圆侧参考点取 A 在拟合圆上的对径点，由调用方解析后传入。
 *
 * @param minimumResult 混合场景最小距离求解结果。
 * @param context 混合测量上下文。
 * @param antipodalPoint 参考点 A 在拟合圆上的对径点。
 * @returns 最大距离参考点结果。
 */
export function deriveMixedMaximumDistanceFromMinimum(
    minimumResult: MeasureClosestPointResult,
    context: MeasureArcCircleMixedContext,
    antipodalPoint: THREE.Vector3,
): MeasureClosestPointResult {
    const { nonCirclePoint } = extractMixedMinimumSidePoints(
        minimumResult,
        context.circleSideIsFirst,
    );

    return computeCenterToTargetReferencePoint(
        context.circleSideIsFirst,
        antipodalPoint,
        nonCirclePoint,
    );
}
